import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronUp';
/** Renders an SVG icon. */
const SvgChevronUp = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M8.204 19.796c.44.439 1.152.439 1.591 0L16 13.59l6.204 6.205a1.125 1.125 0 0 0 1.591-1.591l-7-7a1.125 1.125 0 0 0-1.59 0l-7 7a1.123 1.123 0 0 0 0 1.59Z"
      />
    </svg>
  );
};
SvgChevronUp.displayName = displayName;
export default SvgChevronUp;
